import { render, staticRenderFns } from "./BankAccounts.vue?vue&type=template&id=d5da0d38&scoped=true"
import script from "./BankAccounts.vue?vue&type=script&lang=ts"
export * from "./BankAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5da0d38",
  null
  
)

export default component.exports